export let taxYears = [
  {
    value: 2020,
    label: '2020'
  },
  {
    value: 2019,
    label: '2019'
  }
];

export let returnTypes = [
  {
    value: '7004',
    label: '7004'
  },
  {
    value: '1120',
    label: '1120'
  },
  {
    value: '1120F',
    label: '1120F'
  },
  {
    value: '1065',
    label: '1065'
  },
  {
    value: '990',
    label: '990'
  }
];
